import React from 'react';
import { X, Wrench } from 'lucide-react';

/**
 * Modal de confirmação customizado
 */
export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  onCancel,
  title = 'Confirmar',
  message = '',
  confirmText = 'Sim',
  cancelText = 'Não',
  confirmColor = 'bg-green-600 hover:bg-green-700',
  showIcon = true
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-md z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {showIcon && <Wrench size={24} className="text-white" />}
              <h2 className="text-2xl font-black">{title}</h2>
            </div>
            <button
              onClick={onCancel || onClose}
              className="p-2 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
              aria-label="Fechar"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6">
            <p className="text-lg font-bold text-slate-800 whitespace-pre-line leading-relaxed">
              {message}
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={onCancel || onClose}
              className="flex-1 py-4 rounded-2xl font-black bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 py-4 rounded-2xl font-black text-white transition-colors shadow-lg ${confirmColor}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

